// Document-level navigation in one place, so the shell's policy is testable without
// replacing `window.location` (which the router's browser history reads).
export const hardNavigate = (href: string): void => {
  window.location.assign(href);
};

export const reloadPage = (): void => {
  window.location.reload();
};

// Saves a same-origin attachment without leaving the page, as the browser does for a link to it.
export const downloadFile = (href: string): void => {
  const link = document.createElement('a');
  link.href = href;
  link.download = '';
  link.click();
};

// Follows a URL as a click on a link to it would, e.g. after a save: inside the shell its
// window click handler navigates client side where the route allows; otherwise the browser
// loads the page.
export const followHref = (href: string): void => {
  const link = document.createElement('a');
  link.href = href;
  document.body.appendChild(link);
  link.click();
  link.remove();
};
